import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MessageDialogComponent } from './message-dialog.component';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { SliderModule } from '../slider/slider.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [MessageDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatDividerModule,
    TranslateModule,
    SliderModule,
    MatProgressBarModule,
  ],
  exports: [MessageDialogComponent]
})
export class MessageDialogComponentModule { }
